import {
  vipApp,
} from "../api/api"
function onVipApp(callback) {
  var guid = localStorage.getItem('guid');
  var kmEName = localStorage.getItem('kmEName');
  let data ={
    guid: guid
  }
  vipApp(data).then(result =>{
    if (result.data.status == 200) {
      let resultList = result.data.data.VipApp;
      let timestamp = Date.parse(new Date());
      let currentClassesList = [];
      let currentClasses = {};
      resultList.forEach((item, index) => {
        let timeTamp = Date.parse(item.EndTime);
        if (timeTamp > timestamp) {
          if (item.AppEName == kmEName) {
            item.EndTime = item.EndTime.substring(0, 10);
            currentClassesList.push(item)
          }
        }
      });
      if (currentClassesList.length) {
        let VnOrder = -999;
        currentClassesList.forEach((item, index) => {
          if (item.VnOrder > VnOrder) {
            VnOrder = item.VnOrder;
            currentClasses = item;
          }
        });
        callback({ AppVn: currentClasses.AppVn, isVip: 2 })
      } else {
        callback({ AppVn: 0, isVip: 1 })
      }
    } else {
      callback({ AppVn: 0, isVip: 1 })
    }

  })


}
export default {
  onVipApp
}